module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 38
// module chunks = 0